import { createStore, applyMiddleware } from "redux";
import thunk from 'redux-thunk'
import { compose } from "redux";
import rootReducer from "./reducers/rootReducer";

const comp = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
    rootReducer,
    comp(applyMiddleware(thunk))
);

export default store;